export default {
  font1: 'Lato, Noto Sans, sans-serif',
  font2: 'Arundina Sans, Helvetica, Arial, sans-serif',
  // colorTiffany: '#01a6ad',
  colorTiffany: '#67c7c7',
  colorTiffanyDark: '#08bbc1',
  colorTiffany200: '#00BAC2',
  colorTiffany300: '#5ccdce',
  colorTiffany500: '#01949a',
  colorGray: '#5e5e5e',
  colorGray100: '#979797',
  colorGray300: '#767676',
  colorGrayInactiveStar: '#dfe3e4',
  colorOrange: '#ffc21d',
  colorCoral: '#f97373',
  colorCoralBorder: '#ff672b',
  colorBorder: '#e6e6e6',
  colorRed: '#f94e5b',
  colorImageBackground: '#b3b3b3',
  // colorBackground: '#f8f9fa',
  colorBackground: '#f6f6f6',
  colorBackground500: '#f1f7f7',
  colorHover: '#f7f8f8',
  colorYellow: '#ffc21d',
  // colorGreen: '#7ed321',
  colorGreen: '#26e395',
  colorGreenLight: '#9bf2ce',
  colorWhiteActive: '#ecf0f7',
  colorBlue: '#6c8eae',
  weightLight: '300',
  weightRegular: '400',
  weightMedium: '500',
  weightSemiBold: '500',
  imageScale: '1.2'
}



// WEBPACK FOOTER //
// ./src/theme.js